import AlleventsModule from './containers/alleventsModule'

export {default as AlleventsModuleLayout} from './components/alleventsModuleLayout'

export default AlleventsModule
